import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { AssignBiilsTripComponent } from './assign-biils-trip/assign-biils-trip.component';
import { ArchiveTripComponent } from './archive-trip/archive-trip.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: 'home',
    loadComponent: () => import('./home/welcome/welcome.component').then(m => m.WelcomeComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./user/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'logout',
    loadComponent: () => import('./user/logout/logout.component').then(m => m.LogoutComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./user/join/join.component').then(m => m.JoinComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./user/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'privacy',
    loadComponent: () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'reset-password/:otp/:email',
    loadComponent: () => import('./user/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'scaned-receipts',
    loadComponent: () => import('./expense/receipt/receipt.component').then(m => m.ReceiptComponent),
    canActivate: [authGuard]
  },
  {
    path: 'organization',
    loadComponent: () => import('./organization/organization.component').then(m => m.OrganizationComponent),
    canActivate: [authGuard]
  },
  {
    path: 'userassign',
    loadComponent: () => import('./userassign/userassign.component').then(m => m.UserassignComponent),
    canActivate: [authGuard]
  },
  {
    path: 'scaned-receipt/:page/:billId',
    loadComponent: () => import('./expense/receipt/detail/detail.component').then(m => m.DetailComponent),
    canActivate: [authGuard]
  },
  {
    path: 'about',
    loadComponent: () => import('./about/about.component').then(m => m.AboutComponent),
    canActivate: [authGuard]
  },
  {
    path: 'showRequest',
    loadComponent: () => import('./show-request/show-request.component').then(m => m.ShowRequestComponent),
    canActivate: [authGuard]
  },
  {
    path: 'showOrgRequest',
    loadComponent: () => import('./orgshow-request/orgshow-request.component').then(m => m.OrgshowRequestComponent),
    canActivate: [authGuard]
  },
  {
    path: 'organization-management',
    loadComponent: () => import('./organization-maintain/organization-maintain.component').then(m => m.OrganizationMaintainComponent),
    canActivate: [authGuard]
  },
  {
    path: 'orgHirarchy/:orgId',
    loadComponent: () => import('./emphirarchy/emphirarchy.component').then(m => m.EmphirarchyComponent),
    canActivate: [authGuard]
  },
  {
    path: 'about-us',
    loadComponent: () => import('./about-us/about-us.component').then(m => m.AboutUsComponent)
  },
  {
    path: 'trip',
    loadComponent: () => import('./trip/trip.component').then(m => m.TripComponent),
    canActivate: [authGuard]
  },
  {
    path: 'trips/:tripId',
    loadComponent: () => import('./assign-biils-trip/assign-biils-trip.component').then(m => AssignBiilsTripComponent),
    canActivate: [authGuard]
  },
  {
    path: 'archive-trip',
    loadComponent: () => import('./archive-trip/archive-trip.component').then(m => ArchiveTripComponent),
    canActivate: [authGuard]
  },
  // {
  //   path: 'contact-us',
  //   loadComponent: () => import('./contact-us/contact-us.component').then(m => m.ContactUsComponent)
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
